const TopicComparisonMeasureType = Object.freeze({
  MENTIONS: 'Mentions',
  POSTS: 'Posts',
  POSTS_PERCENT_SHARE: 'PostsPercentShare',
  POSTS_TREND: 'PostsTrend',
  MENTIONS_PERCENT_SHARE: 'MentionsPercentShare',
  MENTIONS_TREND: 'MentionsTrend',
  IMPRESSIONS: 'Impressions',
  NET_SENTIMENT: 'NetSentiment',
  PASSION: 'Passion',
  UNIQUE_AUTHORS: 'UniqueAuthors',
  ENGAGEMENTS: 'Engagements',
  ENGAGEMENT_RATIO_ONLY: 'EngagementRatioOnly',
  COMMENTS: 'Comments',
  LIKES: 'Likes',
  SHARES: 'Shares',
  VIEWS: 'Views',
  DISLIKES: 'Dislikes',
  SCORE: 'Score'
})
export default TopicComparisonMeasureType
export type TopicComparisonMeasureTypeStrings = typeof TopicComparisonMeasureType[keyof typeof TopicComparisonMeasureType]
// RESERVE BELOW
